var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.443 5.15405H3.86081C3.00201 5.15405 2.30371 5.89936 2.30371 6.81454V12.5624C2.30371 13.4782 3.00261 14.2229 3.86081 14.2229H13.443C14.3018 14.2229 15.0001 13.4776 15.0001 12.5624V6.81454C15.0001 5.89872 14.3018 5.15405 13.443 5.15405ZM14.0932 12.5624C14.0932 13.0554 13.9047 13.316 13.443 13.316H3.86081C3.39847 13.316 3.21059 13.0554 3.21059 12.5624V8.78158H14.0932V12.5624ZM14.0932 7.8747H3.21059V6.81454C3.21059 6.3215 3.39847 6.06094 3.86081 6.06094H13.443C13.9047 6.06094 14.0932 6.3215 14.0932 6.81454V7.8747ZM10.6881 11.865C10.6881 11.653 10.8492 11.501 11.0474 11.501H12.2452C12.4434 11.501 12.6045 11.6536 12.6045 11.865C12.6045 12.2959 12.4434 12.4091 12.2452 12.4091H11.0474C10.8492 12.4091 10.6881 12.3083 10.6881 11.865Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 4.97935C6.55 5.22787 6.75147 5.42935 7 5.42935H7.57C7.59425 5.42935 7.61265 5.43159 7.65182 5.43635C7.66428 5.43786 7.67883 5.43963 7.69633 5.44167C7.69825 5.44189 7.70038 5.44215 7.70271 5.44242C7.75138 5.44825 7.88694 5.46449 8.02536 5.4186C8.2216 5.35354 8.33811 5.2032 8.39378 5.04681C8.44005 4.91683 8.45 4.7708 8.45 4.63415V4.24699C8.45 3.84394 8.36277 3.45774 8.20305 3.15485L8.20306 3.15485L8.20185 3.15258C8.04832 2.8654 7.76429 2.55727 7.34439 2.55007L7.34439 2.55H7.33667C6.99843 2.55 6.79503 2.79877 6.70272 2.97024C6.60008 3.16092 6.55 3.3937 6.55 3.62661V4.97935Z",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 3.45C7.49853 3.45 7.7 3.24853 7.7 3C7.7 2.75147 7.49853 2.55 7.25 2.55H3.64063H3.3125C2.73808 2.55 2.27292 2.71136 1.95734 3.05125C1.6477 3.38473 1.55 3.81762 1.55 4.2207V4.52587V8.79832C1.55 9.47138 2.3147 9.73971 2.78297 9.41117C2.78337 9.41089 2.78378 9.4106 2.78418 9.41032L3.27409 9.06926L3.75644 9.52058L3.75743 9.5215C4.05813 9.80117 4.53562 9.80117 4.83632 9.5215L5.32132 9.07042L5.81165 9.41178L5.81307 9.41276C6.06532 9.58694 6.36791 9.5873 6.60222 9.47834C6.83758 9.36889 7.04375 9.12696 7.04375 8.79832V3.61035C7.04375 3.55336 7.1063 3.45 7.25 3.45Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18066 4.95337C3.06417 4.95337 2.96973 5.04781 2.96973 5.16431C2.96973 5.2808 3.06417 5.37524 3.18066 5.37524H4.95254C5.06904 5.37524 5.16348 5.2808 5.16348 5.16431C5.16348 5.04781 5.06904 4.95337 4.95254 4.95337H3.18066Z",
    stroke: "currentColor",
    strokeWidth: 0.421875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40234 6.1897C3.28585 6.1897 3.19141 6.28414 3.19141 6.40063C3.19141 6.51713 3.28585 6.61157 3.40234 6.61157H4.73125C4.84775 6.61157 4.94219 6.51713 4.94219 6.40063C4.94219 6.28414 4.84775 6.1897 4.73125 6.1897H3.40234Z",
    stroke: "currentColor",
    strokeWidth: 0.421875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBill);
export default __webpack_public_path__ + "static/media/Credit Card Bill.d481df7787f87454525b4963801e0014.svg";
export { ForwardRef as ReactComponent };